import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function GeoWithin(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  const _geoWithin = this.filteringService.geoWithin();

  if (!_geoWithin.length) {
    return currentValue;
  }

  const _latBounds = [...new Set(_geoWithin.map((coord) => coord[1]))].sort((a, b) => a - b);
  const _lngBounds = [...new Set(_geoWithin.map((coord) => coord[0]))].sort((a, b) => a - b);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- The listing.geo property may be undefined, so we need to check for that before accessing its coordinates.
  if (!listing.geo) {
    return currentValue;
  }
  const _lat = Number(listing.geo.coordinates[1]);
  const _lng = Number(listing.geo.coordinates[0]);

  if (
    _lat <= _latBounds[0] ||
    _lat >= _latBounds[1] ||
    _lng <= _lngBounds[0] ||
    _lng >= _lngBounds[1]
  ) {
    return false;
  }

  return currentValue;
}
